'use client';

import {cn} from '@/lib/utils';

export default function PageTitle({
  title,
  className
}: {
  title: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        className ||
          'text-[#e31836] text-[30px] leading-[44px] mb-[20px] mt-[20px] font-bold '
      )}
    >
      {title
        .replace(/<br\s*[\/]?>/gi, '\n')
        .split('\n')
        .filter((line) => line.trim() !== '')
        .map((line, index) => {
          return <div key={index}>{line}</div>;
        })}
    </div>
  );
}
